export default "__VITE_ASSET__DVYV1joG__"